import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    // console.log("AthAffLinkController connected!");
  }

  toggleStatus(event) {
    event.preventDefault();

    const linkId = event.currentTarget.dataset.id;
    const url = event.currentTarget.dataset.url;

    fetch(url, {
      method: "PATCH",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const contentType = response.headers.get("content-type") || "";
        if (!contentType.includes("application/json")) {
          throw new Error(`Expected JSON but received ${contentType || "unknown content type"}`);
        }

        return response.json();
      })
      .then((data) => {
        if (data.success) {
          const row = document.getElementById(`athlete-affiliate-link-${linkId}`);
          if (row) {
            // Add fade-out class to trigger animation
            row.classList.add("fade-out");

            // Remove the row after the transition ends
            row.addEventListener("transitionend", () => {
              row.remove();
            });
            if (data.status === "archived") {
              const countElement = document.getElementById("athlete-count");
              if (countElement) {
                const currentCount = parseInt(countElement.textContent, 10);
                countElement.textContent = currentCount - 1;
              }
            }

            if (data.status === "active") {
              const countElement = document.getElementById("athlete-count");
              if (countElement) {
                const currentCount = parseInt(countElement.textContent, 10);
                countElement.textContent = currentCount + 1;
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error toggling status:", error);
      });
  }


  // toggleStatus(event) {
  //   event.preventDefault();

  //   const linkId = event.currentTarget.dataset.id;
  //   const url = event.currentTarget.dataset.url;

  //   fetch(url, {
  //     method: "PATCH",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
  //     }
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       //if (data.success && data.status === "archived") {
  //       if (data.success) {
  //         // Hide the row if status is archived
  //         const row = document.getElementById(`athlete-affiliate-link-${linkId}`);
  //         if (row) {
  //           row.remove();
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error toggling status:", error);
  //     });
  // }
}
